'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  position: relative;\n  border-style: ', ' none none none;\n  border-width: 1px;\n  border-color: ', ';\n  align-items: center;\n  ', ';\n  cursor: ', ';\n  color: ', ';\n  overflow: ', ';\n  padding-right: ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  display: flex;\n  position: relative;\n  border-style: ', ' none none none;\n  border-width: 1px;\n  border-color: ', ';\n  align-items: center;\n  ', ';\n  cursor: ', ';\n  color: ', ';\n  overflow: ', ';\n  padding-right: ', ';\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          &:hover {\n            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);\n          }\n        '], ['\n          &:hover {\n            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);\n          }\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(2px);\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ', ';\n  cursor: not-allowed;\n'], ['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(2px);\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ', ';\n  cursor: not-allowed;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  height: 100%;\n  display: flex;\n  transform: ', ';\n  opacity: ', ';\n  visibility: ', ';\n  ', ';\n'], ['\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  height: 100%;\n  display: flex;\n  transform: ', ';\n  opacity: ', ';\n  visibility: ', ';\n  ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  background: ', ';\n  color: ', ' !important;\n  padding: ', ';\n  font-size: ', ';\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  background: ', ';\n  color: ', ' !important;\n  padding: ', ';\n  font-size: ', ';\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  text-align: center;\n  border-radius: 50%;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ', ';\n  color: ', ';\n  font-size: 20px;\n  margin: 5px;\n'], ['\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  text-align: center;\n  border-radius: 50%;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ', ';\n  color: ', ';\n  font-size: 20px;\n  margin: 5px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _reactDeviceDetect = require('react-device-detect');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Modal = require('../../Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Column = require('./Column.Table');

var _Column2 = _interopRequireDefault(_Column);

var _colors = require('../../../libs/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Color


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var noBorder = _ref.noBorder;
  return noBorder ? 'none' : 'solid';
}, colors.grey, (0, _polished.transitions)('box-shadow .1s ease-in-out'), function (_ref2) {
  var onClick = _ref2.onClick,
      pointer = _ref2.pointer;
  return onClick || pointer ? 'pointer' : 'initial';
}, colors.black, function (_ref3) {
  var actions = _ref3.actions;
  return actions ? 'hidden' : 'initial';
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding ? '23px' : '0px';
}, function (_ref5) {
  var noHover = _ref5.noHover;
  return noHover ? '' : (0, _styledComponents.css)(_templateObject2);
});

var Loader = _styledComponents2.default.div(_templateObject3, colors.red);

var Actions = _styledComponents2.default.div(_templateObject4, function (_ref6) {
  var visible = _ref6.visible;
  return visible ? '' : 'translateX(100%)';
}, function (_ref7) {
  var visible = _ref7.visible;
  return visible ? 1 : 0;
}, function (_ref8) {
  var visible = _ref8.visible;
  return visible ? 'visible' : 'hidden';
}, (0, _polished.transitions)('visibility .3s ease-in-out, opacity .3s ease-in-out, transform .3s ease-in-out'));

var Action = _styledComponents2.default.div(_templateObject5, function (_ref9) {
  var color = _ref9.color;
  return colors[color];
}, function (_ref10) {
  var color = _ref10.color;
  return ['white', 'grey'].includes(color) ? colors.darkGrey : colors.white;
}, _reactDeviceDetect.isMobile ? '0px 8px' : '0px 6px', _reactDeviceDetect.isMobile ? '16px' : '11px');

var ActionsModal = _styledComponents2.default.div(_templateObject6);

var ModalAction = _styledComponents2.default.div(_templateObject7, colors.darkGrey, colors.darkGrey);

var Row = function (_Component) {
  _inherits(Row, _Component);

  function Row() {
    var _ref11;

    var _temp, _this, _ret;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref11 = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref11, [this].concat(args))), _this), _this.state = {
      hover: false
    }, _this.mouseIn = function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({
        hover: true
      });

      !!onMouseEnter && onMouseEnter(e);
    }, _this.mouseOut = function (e) {
      var onMouseLeave = _this.props.onMouseLeave;

      _this.setState({
        hover: false
      });

      !!onMouseLeave && onMouseLeave(e);
    }, _this.showActions = function () {
      return _this.setState({
        hover: true
      });
    }, _this.hideActions = function () {
      return _this.setState({
        hover: false
      });
    }, _this.onActionClick = function (fn) {
      return function () {
        _this.hideActions();

        fn();
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Row, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          noBorder = _props.noBorder,
          loading = _props.loading,
          children = _props.children,
          pointer = _props.pointer,
          portions = _props.portions,
          actions = _props.actions,
          big = _props.big,
          props = _objectWithoutProperties(_props, ['noBorder', 'loading', 'children', 'pointer', 'portions', 'actions', 'big']);

      var hover = this.state.hover;
      var pointerEvents = _reactDeviceDetect.isMobile ? {} : {
        onMouseEnter: this.mouseIn,
        onMouseLeave: this.mouseOut
      };
      return _react2.default.createElement(Container, _extends({
        pointer: pointer,
        noBorder: noBorder,
        actions: actions.length > 0,
        padding: _reactDeviceDetect.isMobile && !!actions.length
      }, props, pointerEvents), _react.Children.map(children(_Column2.default, portions, big), function (component) {
        return (0, _react.cloneElement)(component, {
          portions: portions,
          big: big
        });
      }), !!actions.length && !_reactDeviceDetect.isMobile && _react2.default.createElement(Actions, {
        visible: hover
      }, actions.map(function (action, index) {
        return _react2.default.createElement(Action, {
          key: index,
          color: action.color,
          onClick: action.onClick
        }, _react2.default.createElement(_Icon2.default, {
          icon: action.icon
        }));
      })), !!actions.length && _reactDeviceDetect.isMobile && _react2.default.createElement(Actions, {
        visible: true
      }, _react2.default.createElement(Action, {
        color: 'grey',
        onClick: this.showActions
      }, _react2.default.createElement(_Icon2.default, {
        icon: 'ellipsis1'
      }))), loading && _react2.default.createElement(Loader, null, _react2.default.createElement('div', null, _react2.default.createElement(_Icon2.default, {
        icon: 'loading2',
        spin: true
      }))), !!actions.length && _reactDeviceDetect.isMobile && _react2.default.createElement(_Modal2.default, {
        title: 'Actions',
        icon: 'ellipsis1',
        visible: hover,
        onClose: this.hideActions,
        size: 'small'
      }, function (Content) {
        return _react2.default.createElement(Content, null, _react2.default.createElement(ActionsModal, null, actions.map(function (action, index) {
          return _react2.default.createElement(ModalAction, {
            key: index,
            onClick: _this2.onActionClick(action.onClick)
          }, _react2.default.createElement(_Icon2.default, {
            icon: action.icon
          }));
        })));
      }));
    }
  }]);

  return Row;
}(_react.Component);

Row.propTypes = {
  loading: _propTypes2.default.bool,
  noBorder: _propTypes2.default.bool,
  noHover: _propTypes2.default.bool,
  pointer: _propTypes2.default.bool,
  big: _propTypes2.default.bool,
  children: _propTypes2.default.func,
  portions: _propTypes2.default.number,
  actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    color: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    label: _propTypes2.default.string
  }))
};
Row.defaultProps = {
  noBorder: false,
  noHover: false,
  loading: false,
  pointer: false,
  big: false,
  portions: 1,
  actions: []
};
exports.default = Row;